// tslint:disable-next-line: max-line-length
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationModel, RoutingService, TranslatePipe, TranslationService, UrlPipe } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { CellService, ColumnConfig } from 'material-dynamic-table';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { debounceTime, switchMap, take } from 'rxjs/operators';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { CartExtendService, SavedCartsListPayload } from 'src/app/service/cart/cart-extend.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
// tslint:disable-next-line: max-line-length
import { SavedCartsListActionsCellComponent } from './saved-carts-list-actions-cell/saved-carts-list-actions-cell.component';
// tslint:disable-next-line: max-line-length
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { PaginationComponent } from '../../pagination/pagination.component';
import { SortingComponent } from '../../sorting/sorting.component';
import { TableComponent } from '../../table/table.component';
import { TooltipTextComponent } from '../../tooltip-text/tooltip-text.component';
import { SavedCartsListDescCellComponent } from './saved-carts-list-desc-cell/saved-carts-list-desc-cell.component';
import { SavedCartsListNameCellComponent } from './saved-carts-list-name-cell/saved-carts-list-name-cell.component';
// tslint:disable-next-line: max-line-length

@Component({
  selector: 'app-saved-carts-list',
  templateUrl: './saved-carts-list.component.html',
  styleUrls: ['./saved-carts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatProgressSpinner,
    SortingComponent,
    MatIconButton,
    MatIcon,
    TableComponent,
    RouterLink,
    TooltipTextComponent,
    MatBadge,
    PaginationComponent,
    AsyncPipe,
    DatePipe,
    TranslatePipe,
    UrlPipe,
  ],
})
export class SavedCartsListComponent implements OnInit, OnDestroy {
  savedCartsCount: number;
  showSrp = false;
  savedCartsListSubscription$: Subscription;
  srpSubscription$: Subscription;

  isDesktop = false;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  dateFormatted: any;
  timeout: any;

  payload: SavedCartsListPayload = {
    currentPage: 0,
    fields: 'FULL',
    pageSize: 50,
    savedCartsOnly: true,
    sort: 'byDateSaved',
    sortType: 'DESC',
  };
  columnsSrpOn: ColumnConfig[];
  columnsSrpOff: ColumnConfig[];

  headerNameSubscription: Subscription;
  savedCartsData: any;
  dataSource = new MatTableDataSource<any>();
  dataSourceMobile: any;
  savedCartsData$: Observable<any>;
  isLoadingSavedCartsData: boolean;

  private sortMapping: any = {
    byDateSavedDesc: 'byDateSaved:desc',
    byDateSavedAsc: 'byDateSaved:asc',
    byCreatorNameDesc: 'byCreatorName:desc',
    byCreatorNameAsc: 'byCreatorName:asc',
  };
  sort = 'byDateSavedDesc';

  sortOptions = [
    {
      code: 'byDateSavedAsc',
      selected: false,
    },
    {
      code: 'byDateSavedDesc',
      selected: false,
    },
    {
      code: 'byCreatorNameAsc',
      selected: false,
    },
    {
      code: 'byCreatorNameDesc',
      selected: false,
    },
  ];

  sortLabels: Observable<{
    byDateSavedAsc: string;
    byDateSavedDesc: string;
    byCreatorNameAsc: string;
    byCreatorNameDesc: string;
  }>;

  PaginationModel: PaginationModel = {
    currentPage: 0,
    pageSize: 0,
    sort: null,
    totalPages: 0,
    totalResults: 0,
  };

  activeCountry$: Observable<string> = this.countryService.getActive();

  showGstExclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_EXCLUSIVE)
    )
  );

  constructor(
    protected modalService: StandardModalService,
    private saveCartService: CartExtendService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private routingService: RoutingService,
    private readonly cellService: CellService,
    private breakpointService: BreakpointService,
    private baseStoreService: BaseStoreService,
    private translation: TranslationService,
    private countryService: ShimanoCountryService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    private storageService: StorageService,
    private checkoutServiceExtends?: CheckoutServiceExtends
  ) {
    this.cellService.registerCell('name', SavedCartsListNameCellComponent);
    this.cellService.registerCell('description', SavedCartsListDescCellComponent);
    this.cellService.registerCell('actions', SavedCartsListActionsCellComponent);
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        this.tableLabels(baseStoreData.dateFormat.replace(/\//g, '-'));
      });
  }

  ngOnInit() {
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        if (baseStoreData) {
          this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '');
        }
      });

    this.isDesktop = window.innerWidth >= this.csDesktopWidth;
    this.timeout = setTimeout(() => {
      this.getSavedCartsData(this.payload);
    }, 1000);
    // refresh table after successful restore/delete
    this.savedCartsListSubscription$ = this.componentService.savedCartsListRefresh$.subscribe((success) => {
      if (success) {
        this.getSavedCartsData(this.payload);
        this.storageService.removeSessionStorageItem('isRestoringCart');
      }
    });

    this.componentService.setIsSavingCart(false);
    this.storageService.removeSessionStorageItem('isRestoringCart');

    // get sort labels
    this.sortLabels = this.saveCartService.getSortLabels();

    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.getSavedCartsData(this.payload);
      this.cdr.detectChanges();
    });

    this.storageService.setSessionStorageItem('isSaveCartPage', 'true');
  }

  tableLabels(dateFormatted: string) {
    this.columnsSrpOn = [
      {
        name: 'name',
        displayName: 'Cart Name',
        type: 'name',
        sort: false,
      },
      {
        name: 'code',
        displayName: 'ID',
        type: 'string',
        sort: false,
      },
      {
        name: 'saveTime',
        displayName: 'Date Saved',
        type: 'date',
        sort: false,
        options: {
          dateFormat: dateFormatted,
        },
      },
      {
        name: 'createdBy',
        displayName: 'Created By',
        type: 'string',
        sort: false,
      },
      {
        name: 'totalItems',
        displayName: '# of Items',
        type: 'string',
        sort: false,
      },
      {
        name: 'description',
        displayName: 'Description',
        type: 'description',
        sort: false,
      },
      {
        name: '',
        type: 'actions',
        sort: false,
      },
    ];

    this.columnsSrpOff = [
      {
        name: 'name',
        displayName: 'Cart Name',
        type: 'name',
        sort: false,
      },
      {
        name: 'code',
        displayName: 'ID',
        type: 'string',
        sort: false,
      },
      {
        name: 'saveTime',
        displayName: 'Date Saved',
        type: 'date',
        sort: false,
        options: {
          dateFormat: dateFormatted,
        },
      },
      {
        name: 'createdBy',
        displayName: 'Created By',
        type: 'string',
        sort: false,
      },
      {
        name: 'dealerPrice',
        displayName: 'Total Amount',
        type: 'string',
        sort: false,
      },
      {
        name: 'totalItems',
        displayName: '# of Items',
        type: 'string',
        sort: false,
      },
      {
        name: 'description',
        displayName: 'Description',
        type: 'description',
        sort: false,
      },
      {
        name: '',
        type: 'actions',
        sort: false,
      },
    ];

    // DO NOT CHANGE THE ORDER
    const columnSrpOnTranslations = ['cartName', 'id', 'dateSaved', 'createdBy', 'noOfItems', 'desc'];
    columnSrpOnTranslations.forEach((translate, index) => {
      this.headerNameSubscription = this.translation
        .translate(`cart.savedCart.overview.${translate}`)
        .subscribe((col) => (this.columnsSrpOn[index].displayName = col));
    });
    const columnSrpOffTranslations = ['cartName', 'id', 'dateSaved', 'createdBy', 'totalAmount', 'noOfItems', 'desc'];
    columnSrpOffTranslations.forEach((translate, index) => {
      this.headerNameSubscription = this.translation
        .translate(`cart.savedCart.overview.${translate}`)
        .subscribe((col) => (this.columnsSrpOff[index].displayName = col));
    });
  }

  getSavedCartsData(payload: any) {
    this.isLoadingSavedCartsData = true;
    this.saveCartService
      .getCustomerSavedCarts(payload)
      .pipe(
        switchMap((data) =>
          combineLatest([of(data), this.showGstExclusive$, this.translation.translate(`gst.exclusive`)])
        ),
        debounceTime(0)
      )
      .subscribe(([data, showGstExclusive, gstExclusive]) => {
        this.savedCartsCount = data.pagination.totalResults;
        if (!this.showSrp) {
          this.savedCartsData = data.results.map((nonflatData: any) => ({
            ...nonflatData,
            createdBy: nonflatData.savedBy.name,
            dealerPrice: showGstExclusive
              ? [nonflatData.totalPrice.formattedValue, gstExclusive].join(' ')
              : nonflatData.totalPrice.formattedValue,
          }));
        } else {
          this.savedCartsData = data.results.map((nonflatData: any) => ({
            ...nonflatData,
            createdBy: nonflatData.savedBy.name,
          }));
        }
        this.dataSource = this.savedCartsData;
        this.updatePaginationModel(data.pagination);
        this.isLoadingSavedCartsData = false;
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
  }

  sortChange(sort: string) {
    this.sort = sort;
    [this.payload.sort, this.payload.sortType] = this.sortMapping[sort].split(':');
    this.getSavedCartsData(this.payload);
  }

  goToBulkImport() {
    this.routingService.goByUrl('/import-cart');
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  onRestoreSavedCartModal(name: string, code: string, totalItems: string) {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.RESTORE_SAVED_CART, this.el, this.vcr, {
        cartId: code,
        cartName: name,
        cartTotalItems: totalItems,
        dateFormatted: this.dateFormatted,
        reorder: false,
      })
      ?.pipe(take(1))
      .subscribe();
  }

  onDeleteSavedCartModal(code: string, name: string) {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.DELETE_SAVED_CART, this.el, this.vcr, { cartId: code, cartName: name })
      ?.pipe(take(1))
      .subscribe();
  }

  openError(code: any) {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.OPEN_ERROR, this.el, this.vcr, { cartId: code })
      ?.pipe(take(1))
      .subscribe();
  }

  updatePaginationModel(result: any) {
    this.PaginationModel = {
      currentPage: result.currentPage,
      pageSize: result.pageSize,
      sort: result.sort,
      totalPages: result.totalPages,
      totalResults: result.totalResults,
    };
  }

  pageChange(page: any) {
    this.payload.currentPage = page;
    this.getSavedCartsData(this.payload);
  }

  @HostListener('window:resize')
  onResize() {
    this.isDesktop = window.innerWidth >= this.csDesktopWidth;
  }

  ngOnDestroy() {
    if (this.savedCartsListSubscription$) {
      this.savedCartsListSubscription$.unsubscribe();
    }
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.headerNameSubscription) {
      this.headerNameSubscription.unsubscribe();
    }
    this.storageService.setSessionStorageItem('isSaveCartPage', 'false');
  }
}
